import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { CompetitionsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createCompetition = (data): any => action(types.CREATE_COMPETITION_REQUESTED, data);

export const updateCompetition = (data): any => action(types.UPDATE_COMPETITION_REQUESTED, data);

export const deleteCompetition = (competitionId): any => action(types.UPDATE_COMPETITION_REQUESTED, competitionId);

export const getCompetition = (competitionId): any => action(types.GET_COMPETITION_REQUESTED, competitionId);

export const getAllCompetitions = (
  organisationId: string,
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_COMPETITIONS_REQUESTED, {
  organisationId,
  pagination,
  compile,
});

export const selectCompetition = (competitionId): any => action(types.SELECT_COMPETITION_REQUESTED, {
  currentCompetitionId: competitionId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createCompetitionPending: (payload): any => action(types.CREATE_COMPETITION_PENDING, payload),
  createCompetitionSuccess: (response): any => {
    const currentCompetition = response.entities.competitions[response.result];
    // history.push(`/payment/${currentCompetition.paymentCollection.id}/review`);
    return action(types.CREATE_COMPETITION_SUCCESS, {
      competitionsById: response.entities.competitions,
      currentCompetitionId: response.result,
    });
  },
  createCompetitionFailed: (error): any => action(types.CREATE_COMPETITION_FAIL, { backendErrors: error }),
  updateCompetitionPending: (payload): any => action(types.UPDATE_COMPETITION_PENDING, payload),
  updateCompetitionSuccess: (response): any => action(types.UPDATE_COMPETITION_SUCCESS, {
    competitionsById: response.entities.competitions,
    currentCompetitionId: response.result,
  }),
  updateCompetitionFailed: (error): any => action(types.UPDATE_COMPETITION_FAIL, { backendErrors: error }),
  deleteCompetitionPending: (): any => action(types.UPDATE_COMPETITION_PENDING, {}),
  deleteCompetitionSuccess: (response, userId): any => {
    localStorage.set(userId, { currentCompetitionId: null });
    history.push('/competitions');

    return action(types.DELETE_COMPETITION_SUCCESS, {
      currentCompetitionId: response,
    });
  },
  getCompetitionPending: (): any => action(types.GET_COMPETITION_PENDING, {}),
  getCompetitionSuccess: (response): any => action(types.GET_COMPETITION_SUCCESS, {
    competitionsById: response.entities.competitions,
    currentCompetitionId: response.result,
  }),
  getCompetitionFailed: (error): any => action(types.GET_COMPETITION_FAIL, { backendErrors: error }),
  deleteCompetitionFailed: (error): any => action(types.UPDATE_COMPETITION_FAIL, { backendErrors: error }),
  getAllCompetitionsPending: (pagination): any => action(types.GET_ALL_COMPETITIONS_PENDING, { pagination }),
  getAllCompetitionsSuccess: (response, meta): any => action(types.GET_ALL_COMPETITIONS_SUCCESS, {
    competitionsById: response.entities.competitions,
    competitionIds: response.result,
    meta,
  }),
  getAllCompetitionsFailed: (error): any => action(types.GET_ALL_COMPETITIONS_FAIL, { backendErrors: error }),
};

export default {
  createCompetition,
  updateCompetition,
  deleteCompetition,
  getCompetition,
  getAllCompetitions,
  selectCompetition,
};
